import { CmsApiPersonaQuizBlockData } from 'modules/cms/api/types/blocks/CmsApiPersonaQuizBlock';
import { CmsBlockMapping } from 'modules/cms/blocks/CmsBlockMapping';
import { CmsMappedBlockWidth } from 'modules/cms/mappers/CmsMappedBlockWidth';

import { CmsAmpPersonaQuizBlock } from './CmsAmpPersonaQuizBlock';
import { CmsPersonaQuizBlock } from './CmsPersonaQuizBlock';

export const CmsPersonaQuizBlockMapping: CmsBlockMapping<CmsApiPersonaQuizBlockData> =
  {
    invariant: [],
    width: CmsMappedBlockWidth.NARROW,
    Component: CmsPersonaQuizBlock,
    AmpComponent: CmsAmpPersonaQuizBlock,
  };
